import { useApplicantAPI } from "@certn/api";
import { components } from "@certn/api/generated-schemas/applicant-portal";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  ESignDocument,
  Link,
  Modal,
  ModalTrigger,
  PrimaryButton,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Trans } from "react-i18next";

import { useApplicationFormContext } from "../../ApplicationFormContext";
import { ConsentNoticeModal } from "../ConsentNoticeModal";

type BiometricConsentResponse =
  components["schemas"]["BiometricConsentTemplateResponse"];

interface Props {
  linkName: string;
  contractId: string;
  modalHeader: string;
}

export function BiometricNoticeModal(props: Props) {
  const { linkName, modalHeader } = props;
  const { caseId } = useApplicationFormContext();
  const { enableSuperdocApplicantAgreementTemplates } = useFlags();

  const { data: biometricConsentData } = useApplicantAPI(
    enableSuperdocApplicantAgreementTemplates
      ? (`/api/internal/applicant/case/${caseId}/biometric-consent/` as "/api/internal/applicant/case/{id}/biometric-consent/")
      : null
  );

  const consentData = biometricConsentData as
    | BiometricConsentResponse
    | undefined;

  if (!enableSuperdocApplicantAgreementTemplates || !consentData?.esign?.url) {
    return <ConsentNoticeModal {...props} />;
  }

  return (
    <ModalTrigger
      trigger={
        <Link
          testID={`open-${linkName}-notice-modal-link`}
          linkStyle="monochrome"
        >
          {linkName}
        </Link>
      }
    >
      <Modal>
        <Dialog width={640}>
          {({ close }) => (
            <>
              <DialogHeader>{modalHeader}</DialogHeader>

              <DialogContent>
                <div className={styles.esignContainer}>
                  <ESignDocument
                    data={consentData?.esign}
                    style={{ height: "100%", width: "100%" }}
                  />
                </div>
              </DialogContent>

              <DialogFooter>
                <PrimaryButton onPress={close}>
                  <Trans>Close</Trans>
                </PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}

const styles = {
  esignContainer: css({
    height: "60vh",
    minHeight: "400px",
    width: "100%",
  }),
};
